import { jsx } from 'react/jsx-runtime';
import { memo, createElement } from 'react';
import { styled } from 'styled-components';
import RecapSummaryModal from './RecapSummaryModal.js';
import { Button } from '@fabric-app/ui/components/Button';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { GeneratedIcon } from '@fabric-app/icons/icons';

const SummaryButton = styled(Button).attrs((p) => {
  return {
    variant: "bg-tertiary",
    size: "sm",
    ...p
  };
}).withConfig({
  displayName: "RecapSummaryButton__SummaryButton",
  componentId: "sc-5dc2c5c5-0"
})([
  `display:inline-flex;border-radius:10px;font-weight:500;height:32px;padding:0 8px;color:`,
  `;`
], cssVar["color-text-tertiary"]);
const RecapSummaryButton = ({ date, frequency, field, buttonProps }) => {
  return /* @__PURE__ */ jsx(RecapSummaryModal, {
    date,
    frequency,
    field,
    children: /* @__PURE__ */ createElement(SummaryButton, {
      ...buttonProps,
      key: "summary-button",
      children: [
        /* @__PURE__ */ jsx(GeneratedIcon, {
          size: 16
        }),
        "Summary"
      ]
    })
  });
};
const RecapSummaryButton$1 = /* @__PURE__ */ memo(RecapSummaryButton);

export { RecapSummaryButton$1 as default };
//# sourceMappingURL=RecapSummaryButton.js.map
